import { loadStripe } from '@stripe/stripe-js';

    const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_key';
    export const stripe = loadStripe(stripePublishableKey);

    // Stripe Price IDs (set these in your Stripe dashboard)
    export const STRIPE_PRICES = {
      PRO_MONTHLY: 'price_1OGqGj2eZvKYlo2C6ZrL8tXH',
      PRO_YEARLY: 'price_1OGqH22eZvKYlo2C6ZrJ8tXH' // R$ 100/year
    };

    // Plan Features - Updated to remove SaaS references
    export const PLAN_FEATURES = {
      FREE: {
        name: 'Plano Gratuito',
        price: 'R$ 0',
        features: [
          'Até 10 produtos',
          'Menu digital básico',
          'Suporte por email',
          'Anúncios na plataforma'
        ],
        limitations: [
          'Produtos limitados',
          'Recursos básicos',
          'Com anúncios'
        ]
      },
      PRO: {
        name: 'Plano Profissional',
        price: 'R$ 100',
        priceYearly: 'R$ 100',
        billing: 'anual',
        features: [
          'Produtos ilimitados',
          'Menu digital avançado',
          'Sistema de cupons',
          'Entregadores próprios',
          'Analytics avançado',
          'Exportação CSV',
          'Sem anúncios',
          'Suporte prioritário',
          'Chat com clientes',
          'Relatórios detalhados',
          'Posts no blog direto'
        ]
      }
    };